@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  margin: 0 10px 4px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  max-width: 100%;
  color: var(--dark-60);

  [data-autopilot-system-redesign='on'] & {
    margin-bottom: 2px;

    &.hovered {
      .label {
        background-color: initial;
      }
    }
  }

  button > span > span {
    font-weight: 400;

    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-book;
      letter-spacing: 0.12px;
      color: var(--dark-40);
    }
  }

  svg {
    color: rgba(0, 0, 0, 0.7);

    [data-autopilot-system-redesign='on'] & {
      color: var(--dark-40);
    }
  }

  &.hovered {
    .label {
      background-color: var(--dark-4);
    }
  }

  @include for-phone-only {
    &.expanded {
      border-bottom: none;
    }
  }
}

.seeAllButton {
  @include transition(0.4s);
  opacity: 1;
  pointer-events: all;

  a {
    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-medium;
      color: var(--dark-60);
    }
  }
}

.label {
  @include transition;
  height: 18px;
  display: flex;
  align-items: center;
  column-gap: 2px;
  border-radius: 4px;

  .labelText {
    color: var(--dark-60);
  }

  svg {
    min-width: 12px;
    transition: transform 200ms ease-out;
  }

  .expanded & {
    svg {
      transform: rotate(90deg);
    }
  }
}

@media (min-width: $phoneMaxWidth) {
  .seeAllButton {
    opacity: 0;
    pointer-events: none;

    [data-sidebar-is-hovered='true'] & {
      opacity: 1;
      pointer-events: all;
    }
  }
}
